<div class="jumbotron text-center">
  <div class="container">
    <!-- <div class="row">
    <div class="col-sm-6" style="text-align:left">
      <button type="button" class="btn btn-outline-primary" (click)="open(content)">Add New Employee</button>
    </div>
    <div class="col-sm-6">
      <input class="form-control" type="text" placeholder="Search employee" [(ngModel)]="employeeName">
    </div>
  </div> -->
  <br>
    <div class="row">
      <div class="col-sm-12 table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr class="table-secondary">
              <th>#</th>
              <th>Name</th>
              <th>Role</th>
              <th colspan="2">ID Number</th>
              <th>Country</th>
              <th colspan="2">Bank A\C</th>
              <th>Basic Salary</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (list_length == 0) {
              <tr>
                <td colspan="9">No data found</td>
              </tr>
            }
            @for (item of filteredItems | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track item; let i = $index) {
              <tr>
                <td>{{ ((page-1) * pageSize) + (i+1) }}</td>
                <td>
                  <span class="badge bg-success" style="cursor: pointer;"
                  (click)="open_employee_details(employee_details_content, item.employee)">{{item.employee.name}}</span>
                  <!-- <span *ngIf="item.status=='INACTIVE'" class="badge bg-primary" style="cursor: pointer;"
                (click)="open_employee_details(employee_details_content, item)">{{item.name}}</span>
                <span *ngIf="item.status=='LEAVE'" class="badge bg-dark" style="cursor: pointer;"
                  (click)="open_employee_details(employee_details_content, item)">{{item.name}}
                </span>
                <br>
                  <span *ngIf="item.status=='LEAVE'" class="badge bg-dark" style="cursor: pointer;"
                    (click)="open_employee_details(employee_details_content, item)">
                    On leave - {{item.status_from_date | date:'dd/MM/yyyy'}} to {{item.status_to_date |
                    date:'dd/MM/yyyy'}}
                  </span>
                  <span *ngIf="item.status=='TERMINATED'" class="badge bg-light" style="cursor: pointer;"
                  (click)="open_employee_details(employee_details_content, item)">{{item.name}}</span>
                  <span *ngIf="item.status=='ESCAPE'" class="badge bg-warning" style="cursor: pointer;"
                  (click)="open_employee_details(employee_details_content, item)">{{item.name}}</span> -->
                </td>
                <td>
                  @if (item.role=='doctor') {
                    <span class="badge bg-dark">{{item.role | titlecase}}</span>
                  }
                  @if (item.role=='staff') {
                    <span class="badge bg-info">{{item.role | titlecase}}</span>
                  }
                  @if (item.role=='accountant') {
                    <span class="badge bg-primary">{{item.role |
                    titlecase}}</span>
                  }
                </td>
                <!-- <td *ngIf='item.id_card__path!=null'><a href="{{item.id_card__path}}"
              target="_blank">{{item.employee.id_number}}</a></td> -->
              <td>
                {{item.employee.id_number}}
              </td>
              <td>
                @if (item?.employee.id_expiry_date) {
                  <span class="badge bg-dark" style="font-size: small;">
                  {{item.employee.id_expiry_date | date}}</span>
                }
              </td>
              <td>{{item.employee.country}}</td>
              <td>{{item.employee.bank_name | titlecase }} </td>
              <td>{{item.employee.account_number }}</td>
              <td>{{item.employee.basic_salary | currency:'OMR'}}</td>
              <td style="white-space: nowrap; width: 1%;">
                <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                  dir="auto">
                  <button disabled type="button" class="btn btn-danger" (click)="onDelete(item.employee.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                      fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                      <path fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                    </svg>
                  </button>
                  <button type="button" class="btn btn-secondary" (click)="edit(content2, item.employee)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                      fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                      <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                    </svg>
                  </button>
                  <button type="button" class="btn btn-success" (click)="reset_balance(item.employee.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                      fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                      <path
                        d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                  </button>
                  <!-- <button type="button" class="btn btn-warning" (click)="edit(content3, item.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                    <path
                      d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                  </svg>
                </button> -->
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12 pagination-footer">
    <ngb-pagination
      class="mb-0"
      [collectionSize]="filteredItems.length"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="5"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
    ></ngb-pagination>
  </div>
</div>
</div>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">New Employee</h4>

    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label for="name" class="form-label">Name</label>
      <input type="text" class="form-control" [(ngModel)]="item.name" id="name" placeholder="Full Name">
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="phone" class="form-label">Mobile Number</label>
          <input type="number" class="form-control" [(ngModel)]="item.phone" id="phone"
            placeholder="91234567">
        </div>
        <div class="col">
          <label for="email" class="form-label">email <small>(Optional)</small></label>
          <input type="email" class="form-control" [(ngModel)]="item.email" id="email"
            placeholder="mail@example.com">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="bank_name" class="form-label">Bank Name</label>
          <input type="text" class="form-control" [(ngModel)]="item.bank_name" id="bank_name"
            placeholder="Bank Name">
        </div>
        <div class="col">
          <label for="account_number" class="form-label">Bank Account No.</label>
          <input type="number" class="form-control" [(ngModel)]="item.account_number" id="account_number"
            placeholder="023456789123451">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="basic_salary" class="form-label">Basic Salary</label>
          <input type="number" class="form-control" [(ngModel)]="item.basic_salary" id="basic_salary">
        </div>
        <div class="col">
          <label for="daily_allowance" class="form-label">Daily Price</label>
          <input type="number" class="form-control" [(ngModel)]="item.daily_allowance" id="daily_allowance">
        </div>
        <div class="col">
          <label for="hourly_overtime" class="form-label">OT Price (h)</label>
          <input type="number" class="form-control" [(ngModel)]="item.hourly_overtime" id="hourly_overtime">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="id_number" class="form-label">Id Number</label>
          <input type="text" class="form-control" [(ngModel)]="item.id_number" id="id_number"
            placeholder="123456789">
        </div>
        <div class="col">
          <label for="id_expiry_date" class="form-label">Id Expiry Date</label>
          <input type="date" class="form-control" [(ngModel)]="item.id_expiry_date" id="id_expiry_date">
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label for="id_attachment" class="form-label">Id Card Copy</label>
      <input type="text" class="form-control" [(ngModel)]="item.id_attachment" id="id_attachment" hidden>
      <input type="file" class="form-control" id="file" (change)="fileChange($event)">
    </div>
    <div class="mb-3">
      <label for="work_location" class="form-label">Place of Work</label>
      <input type="text" class="form-control" [(ngModel)]="item.work_location" id="work_location"
        placeholder="company name">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnSubmit()">Add</button>
  </div>
</ng-template>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Employee Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label for="name" class="form-label">Name</label>
      <input type="text" class="form-control" [(ngModel)]="new_item.name" id="name" placeholder="Full Name">
    </div>
    <div class="mb-3">
      <label for="id_number" class="form-label">Id Number</label>
      <input type="text" class="form-control" [(ngModel)]="new_item.id_number" id="id_number"
        placeholder="123456789">
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="country" class="form-label">Country</label>
          <input type="text" class="form-control" [(ngModel)]="new_item.country" id="country"
            placeholder="Employee Nationality">
        </div>
        <div class="col">
          <label for="gender" class="form-label">Gender</label>
          <select class="form-select" [(ngModel)]="new_item.gender" id="gender">
            <option value="0">--- Select ---</option>
            <option value='male'>Male</option>
            <option value='female'>Female</option>
          </select>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label for="basic_salary" class="form-label">Basic Salary</label>
      <input type="number" class="form-control" [(ngModel)]="new_item.basic_salary" id="basic_salary">
    </div>
    <div class="mb-3">
      <label for="bank_name" class="form-label">Bank Name</label>
      <input type="text" class="form-control" [(ngModel)]="new_item.bank_name" id="bank_name"
        placeholder="Bank Name">
    </div>
    <div class="mb-3">
      <label for="account_number" class="form-label">Bank Account No.</label>
      <input type="number" class="form-control" [(ngModel)]="new_item.account_number" id="account_number"
        placeholder="023456789123451">
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="birth_date" class="form-label">Date of Birth</label>
          <input type="date" class="form-control" [(ngModel)]="new_item.birth_date" id="birth_date">
        </div>
        <div class="col">
          <label for="id_expiry_date" class="form-label">Id Expiry Date</label>
          <input type="date" class="form-control" [(ngModel)]="new_item.id_expiry_date" id="id_expiry_date">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(new_item_id)">Update</button>
  </div>
</ng-template>

<ng-template #content3 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Update Status</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label for="status" class="form-label">Status</label>
      <select class="form-select" [(ngModel)]="employee_status.status" id="status">
        <option value="0">--- Select ---</option>
        <option value='ACTIVE'>Active</option>
        <option value='INACTIVE'>Not Active</option>
        <option value='LEAVE'>Leave</option>
        <option value='TERMINATED'>Terminated</option>
        <option value='ESCAPE'>{{'Escape'}}</option>
      </select>
    </div>
    <div class="mb-3">
      <label for="date_from" class="form-label">from Date</label>
      <input type="date" class="form-control" id="date_from" [(ngModel)]="employee_status.status_from_date">
    </div>
    <div class="mb-3">
      <label for="date_to" class="form-label">to date</label>
      <input type="date" class="form-control" id="date_to" [(ngModel)]="employee_status.status_to_date">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="updateStatus(new_item_id)">Update</button>
  </div>
</ng-template>

<ng-template #employee_details_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Employee Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <div class="card border-secondary mb-3" style="width: 100%;">
            <div class="card-header">
              <b>Employee</b>
            </div>
            <div class="card-body">
              <ul class="list-group list-group-flush text-secondary">
                <li class="list-group-item">Name <span
                class="float-end">{{employee_details.name}}</span></li>
                <li class="list-group-item">Phone <span
                class="float-end">{{employee_details.phone}}</span>
              </li>
              <li class="list-group-item">email <span
              class="float-end">{{employee_details.email}}</span>
            </li>
            <li class="list-group-item">Gender <span class="float-end">{{employee_details.gender |
            uppercase}}</span>
            <li class="list-group-item">Id Number <span
            class="float-end">{{employee_details.id_number}}</span>
            <li class="list-group-item">Date of Birth <span
            class="float-end">{{employee_details.birth_date | date}}</span>
          </li>
          <li class="list-group-item">Id Expiry Date <span
          class="float-end">{{employee_details.id_expiry_date | date}}</span>
        </li>
        <li class="list-group-item">Nationality <span
        class="float-end">{{employee_details.country}}</span>
      </li>
    </ul>
  </div>
</div>
</div>
<div class="col">
  <div class="card border-secondary mb-3" style="width: 100%;">
    <div class="card-header">
      <b>Salary Details</b>
    </div>
    <div class="card-body">
      <ul class="list-group list-group-flush text-secondary">
        <li class="list-group-item">Basic Salary <span
        class="float-end">{{employee_details.basic_salary}}</span></li>
        <li class="list-group-item">Bank Name<span
        class="float-end">{{employee_details.bank_name}}</span>
      </li>
      <li class="list-group-item">Account Number<span
      class="float-end">{{employee_details.account_number}}</span>
    </li>
  </ul>
</div>
</div>
<div class="card border-secondary mb-3" style="width: 100%;">
  <div class="card-header">
    <b>Leave Balance <small>(since {{leaves_months}} months)</small></b>
  </div>
  <div class="card-body">
    <ul class="list-group list-group-flush text-secondary">
      <li class="list-group-item">Anuual Leaves
        <span class="float-end badge bg-primary">{{employee_details.anuual_leaves}} /
        {{employee_details.anuual_leaves_left}}</span>
      </li>
      <li class="list-group-item">Sick Leaves
        <span class="float-end badge bg-primary">{{employee_details.sick_leaves}} /
        {{employee_details.sick_leaves_left}}</span>
      </li>
      <li class="list-group-item">Personal Leaves
        <span class="float-end badge bg-primary">{{employee_details.personal_leaves}}</span>
      </li>
    </ul>
  </div>
</div>
</div>
</div>
</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" aria-label="Close"
  (click)="modal.dismiss('Cross click')">Ok</button>
</div>
</ng-template>